import { Textarea as BaseTextarea, TextareaProps } from "baseui/textarea";
import {
  Theme,
  useTheme,
} from "@src/common/components/ThemeProvider/ThemeProvider";

const Textarea: React.FC<TextareaProps> = (props) => {
  const { effectiveTheme } = useTheme();
  const isDark = effectiveTheme === Theme.DARK;

  return (
    <BaseTextarea
      {...props}
      overrides={{
        Input: {
          style: {
            backgroundColor: isDark ? "rgb(11 21 35)" : "rgb(249 250 251)",
            color: isDark ? "rgb(243 244 246)" : undefined,
            colorScheme: isDark ? "dark" : "light",
            ...props.overrides?.Input?.style,
          },
        },
        ...props.overrides,
      }}
    />
  );
};

export default Textarea;
